import { useT } from "../i18n";
import { useQueryClient } from "react-query";
import { useDetachRechnungenVonZahllauf } from "../client/hooks";
import { enqueueSnackbar } from "notistack";
import { useZahllaufContext } from "../contexts/ZahllaufContext";

interface detachZahllaufHandlerProps {
  alleRechnungen: string[] | undefined;
}

export function useDetachZahllaufHandler({
  alleRechnungen,
}: detachZahllaufHandlerProps) {
  const { t } = useT("zahllauf");
  const queryClient = useQueryClient();
  const detachZahllauf = useDetachRechnungenVonZahllauf();
  const { incrementServerKeyVersion } = useZahllaufContext();

  async function detachZahllaufHandler() {
    if (alleRechnungen && alleRechnungen.length > 0) {
      try {
        await detachZahllauf({ rechnungen: alleRechnungen });
        await queryClient.invalidateQueries({
          queryKey: ["zahllauf"],
          exact: false,
        });
        incrementServerKeyVersion();
        enqueueSnackbar(t("paymentrun-detached"), { variant: "success" });
      } catch (e) {
        enqueueSnackbar(t("paymentrun-detached-error"), { variant: "error" });
      }
    } else {
      enqueueSnackbar(t("no-invoices-choosed"), { variant: "warning" });
    }
  }
  return {
    detachZahllaufHandler,
  };
}
